<template>
    <div class="FirstLogin" v-show="show">
        <div class="row">
            <div class="Utility--center col-md-6 col-md-offset-3">
                <h1 class="FirstLogin__title">Welcome to the new<br>SIMI Motorstats</h1>
                <p class="FirstLogin__text">
                    We have loads of great new features that we would love to tell you about.<br>
                </p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <img src="/images/help-center/help-overlay.png" style="width: 100%">
            </div>
        </div>

        <div class="row">
            <div class="Utility--center col-md-6 col-md-offset-3">
                <a href="#" class="Button" @click.prevent="close">Continue to Motorstats</a>
            </div>
        </div>

        <div class="row">
            <div class="Utility--center col-md-6 col-md-offset-3">
                <p class="FirstLogin__text FirstLogin__text--fa">
                    <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                </p>
                <p class="FirstLogin__text">
                    You can find video tutorials and support contact information in the Help Centre by click on the
                    question mark in the top right corner of the screen.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },

        props: {
            shouldDisplay: {
                type: Boolean,
                required: true,
            }
        },

        mounted() {
            if (this.shouldDisplay) {
                this.show = true;
                this.$http.post('/first-login');
            }
        },

        methods: {
            close() {
                this.show = false;
            }
        }
    }
</script>